export default __webpack_public_path__ + "static/media/loader.50c42ee9.gif";